<script>
	export let content = {
		ratingsImage: '',
		ratingsAlt: '',
		socialHeader: '',
		socials: [
			{
				src: ``,
				alt: '',
				href: ''
			}
		],
		popularResourcesLinks: [
			{
				id: '',
				text: '',
				href: '',
				aria: '',
				target: ''
			}
		],
		moreAbcmouseLinks: [
			{
				id: '',
				text: '',
				href: '',
				aria: '',
				target: ''
			}
		]
	};
</script>

<section class="flex flex-col items-center justify-items-center">
	<picture>
		<img
			loading="lazy"
			class="mb-[3rem] mt-[1rem] w-[11.1rem] sm:w-[28.2rem] sm:px-0 sm:pb-[5rem] sm:pt-[0rem]"
			src={content.ratingsImage}
			alt={content.ratingsAlt}
		/>
	</picture>

	<div class="grid grid-cols-1 justify-items-center gap-2 md:my-[6rem]">
		<h2
			class="bg-gradient-to-r from-[#0395FF] via-[#156FF7] to-[#0494F5] bg-clip-text pb-[0.5rem] text-center text-[1.6rem] font-bold leading-none text-transparent sm:text-[2.4rem]"
		>
			{content.socialHeader}
		</h2>

		<div
			class="grid w-full max-w-[19rem] grid-cols-4 justify-center gap-[1.3rem] sm:max-w-[28.2rem]"
		>
			{#each content.socials as item}
				<a id={item.alt} href={item.href} target="_blank" tabindex="0" aria-label={item.alt}>
					<img src={item.src} width="100" height="100" alt={item.alt} data-track-id={item.alt} />
				</a>
			{/each}
		</div>
	</div>

	<div class="mb-[4rem] mt-[6rem] flex flex-row gap-[4rem] sm:gap-[10rem]">
		<div class="flex flex-col items-center gap-4">
			<h2 class="text-center text-[1.2rem] font-semibold text-black sm:text-[1.9rem]">
				Popular Resources
			</h2>
			<ul
				class="m-0 grid list-none grid-cols-1 justify-center gap-[.5rem] p-0 text-center text-[#033EAA] sm:gap-4"
			>
				{#each content.popularResourcesLinks as item}
					<li>
						<a
							id={item.id}
							href={item.href}
							target={item.target}
							aria-label={item.aria}
							class="font-poppins text-[1.6rem] sm:text-[1.9rem]"
						>
							<span data-track-id={item.id}>{item.text}</span>
						</a>
					</li>
				{/each}
			</ul>
		</div>

		<div class="flex flex-col items-center gap-4">
			<h2 class="text-center text-[1.2rem] font-semibold text-black sm:text-[1.9rem]">
				More ABCmouse®
			</h2>
			<ul
				class="m-0 grid list-none grid-cols-1 justify-center gap-[.5rem] p-0 text-center text-[#033EAA] sm:gap-4"
			>
				{#each content.moreAbcmouseLinks as item}
					{#if item?.type && item.type === 'callback'}
						<button
							on:click|preventDefault={item?.callback}
							id={item.id}
							aria-label={item.aria}
							class="font-poppins text-[1.6rem] sm:text-[1.9rem]">{item.text}</button
						>
					{:else}
						<li>
							<a
								id={item.id}
								href={item.href}
								target={item.target}
								aria-label={item.aria}
								class="font-poppins text-[1.6rem] sm:text-[1.9rem]"
							>
								<span data-track-id={item.id}>{item.text}</span>
							</a>
						</li>
					{/if}
				{/each}
			</ul>
		</div>
	</div>

	<picture>
		<img
			class="mb-[5rem] w-[16.2rem] self-center sm:w-[26.7rem] md:mb-[10rem] md:mt-[5rem]"
			width="393"
			height="63"
			src="/assets-mkt/routes/home/logo_large_v1.png"
			alt="ABCmouse logo"
		/>
	</picture>
</section>
